import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import HomeView from "../views/HomeView.vue";
import PagesName from "@/db/pagenames";

const pages = new PagesName();

const routes: Array<RouteRecordRaw> = [
  
  {
    path: "/",
    name: pages.LandingPage,
    component: () => import("../views/utilitarios/landingpage.vue"),
  },
  {
    path: "/comofunciona",
    name: pages.HowItsWorks,
    component: () => import("../views/utilitarios/comofunciona.vue"),
  },
  {
    path: "/beira_boladas",
    name: pages.Homepage,
    component: HomeView,
  },
  {
    path: "/beiraboladas/annoucement/:id",
    name: pages.useritemanaucement,
    component: () => import ("../views/anaucementduserdetailhepage.vue"),
    props:true
  },
  {
    path: "/beiraboladas/auction/:id",
    name: pages.autiondetailuser,
    component: () => import ("../views/autiondetailforuser.vue"),
    props:true
  },

  {
    path: "/dashboard",
    name: pages.dashboardPage,
    component: () => import("../views/dashbosrd.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/addauctionpage",
    name: pages.addAution,
    component: () => import("../views/auction/addautionpage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/auctionList",
    name: pages.autionList,
    component: () => import("../views/auction/autionlist.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/addanaucementes",
    name: pages.addAnaucements,
    component: () => import("../views/anuncios/addanaucements.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/anauclist",
    name: pages.AnaucementsList,
    component: () => import("../views/anuncios/anaucemnteList.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/login",
    name: pages.login,
    component: () => import("../views/AUTENTYICATION/login.vue"),
  },
  {
    path: "/criarcontas",
    name: pages.criarconta,
    component: () => import("../views/AUTENTYICATION/criarconta.vue"),
  },
  {
    path: "/privacy",
    name: pages.privacy,
    component: () => import("../views/utilitarios/politicadeprivacidade.vue"),
  },
  {
    path: "/privacy-carta-moz",
    name: "cartamozpro",
    component: () => import("../views/utilitarios/cartamozpro.vue"),
  },
  {
    path: "/NONGA",
    name: "NHONGA",
    component: () => import("../views/utilitarios/bighonga.vue"),
  },
  {
    path: "/privacy-vaidarnamoro",
    name: "vaidarnamoro",
    component: () => import("../views/utilitarios/vaidarnamoro.privacy.vue"),
  },
  
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
